export const MAX_LOCATIONS_IN_PROFILE = 3;
export const FULL_PROFILE_SCORE = 100;
